/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': "Couleur d'arrière-plan",
  'company-hub.section-extension.config-panel.content-width-field.full-label': 'Pleine largeur',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': 'Pleine largeur',
  'company-hub.section-extension.config-panel.content-width-field.label': 'Largeur du contenu',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': 'Étroit',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': 'Étroit',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': 'Large',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': 'Large',
  'company-hub.section-extension.config-panel.preamble':
    'Organisez les éléments en sections personnalisables. {supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'En savoir plus sur la conception de votre hub.',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'Organisez les éléments connexes en sections avec des arrière-plans et des styles personnalisables.',
  'company-hub.section-extension.config-panel.title': 'Section',
  'company-hub.section-extension.error-loading-content': 'Erreur lors du chargement du contenu',
  'company-hub.section-extension.manifest.content.header': 'Donnez un titre à votre section',
  'company-hub.section-extension.manifest.content.placeholder-title': 'Espace réservé',
  'company-hub.section-extension.manifest.content.sub-header':
    'Organisez les éléments en sections avec des arrière-plans personnalisables.',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'Section',
  'company-hub.section-extension.manifest.extension-title': 'Section [Nouveau]',
  'company-hub.section-extension.manifest.macro-description': 'Regroupez les éléments avec un arrière-plan',
};
